import React from "react";
import '../Common.scss';
import styles from './standardInstruction.module.scss';
import img1 from '../../../assets/counterTop-1.png';
import img2 from '../../../assets/counterTop-2.png';
export default class StandardInstructionPage extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        return (
            <React.Fragment>
            <div className={styles['instructionPage']}>
                <div className={styles['page-name']}>
                   {pageDetails?.name}
               </div>
               <div className={styles["pageImages"]}>
                    <div className={styles['imgContainer1']}>
                       <img crossOrigin="anonymous" src={img1} alt=""/>
                    </div>
                    <div className={styles['imgContainer2']}>
                       <img crossOrigin="anonymous" src={img2} alt=""/>
                    </div>
               </div>
            </div>
        </React.Fragment>
        )
    }

}